import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/services';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  constructor(
    public authService: AuthService,
    private router: Router,
    private location: Location,
  ) {}

  ngOnInit(): void {}

  goTo(back: boolean = false) {
    if (back) {
      this.location.back();
    } else {
      this.router.navigate(['/licenses']);
    }
  }
}
